import { render, staticRenderFns } from "./BoardDetails.vue?vue&type=template&id=7df924ca&scoped=true"
import script from "./BoardDetails.vue?vue&type=script&lang=js"
export * from "./BoardDetails.vue?vue&type=script&lang=js"
import style0 from "./BoardDetails.vue?vue&type=style&index=0&id=7df924ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df924ca",
  null
  
)

export default component.exports